import { Outlet, createFileRoute } from "@tanstack/react-router";

import { VStack } from "@/components/Layout";

import { ContractProfileHeader } from "./_layout/_index/-components/ContractProfileHeader";

export const Route = createFileRoute("/_staff/contract/$id/_layout")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <VStack className="gap-0">
      <ContractProfileHeader />
      <Outlet />
    </VStack>
  );
}
